import React from 'react';
import { useTranslation } from 'react-i18next';
import PageContent from 'components/Generic/PageContent';
import ClientReports from './ClientReports';

const ClientReportsPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <PageContent title={t('reports.client.title')}>
      <ClientReports />
    </PageContent>
  );
};
export default ClientReportsPage;
